export default function deleteOfflineKey(existKey) {
  let keys = JSON.parse(localStorage.getItem("VueOfflineStorageKeys")) || [];
  const index = keys.indexOf(existKey);
  if (index > -1) keys.splice(index, 1);
  localStorage.setItem("VueOfflineStorageKeys", JSON.stringify(keys));
}
